import { useCallback, useEffect, useRef, useState } from "react";
import { io, ManagerOptions, Socket, SocketOptions } from "socket.io-client";
import { useAppDispatch, useAppSelector } from "../../common/store";
import { setIsChatWebsocketConnected } from "../../common/store/app-state/app-state-slice";
import { sendMessageLogSubmission } from "../../common/store/chat/thunks/send-message-log";
import VurbalizeEvents from "../../common/types/dto/chat/vurbalize-events";
import { SocketMessageType } from "../contexts/constants/socket-message-type";
import { CORS_ERROR_KEY } from "../../common/api/axios-client";

export const useWebsocket = (uri?: string, opts?: Partial<ManagerOptions & SocketOptions>) => {
  const socket = useRef<Socket>();
  const dispatch = useAppDispatch();
  const isReadyHeartbeat = useAppSelector(state => state["app-state"].isReadyHeartbeat);

  const onConnect = useCallback(() => {
    dispatch(setIsChatWebsocketConnected(true));
  }, []);

  const onDisconnect = useCallback(() => {
    dispatch(setIsChatWebsocketConnected(false));
    dispatch(sendMessageLogSubmission({ data:{
      message: 'Socket disconnected',
      event_name: VurbalizeEvents.SOCKET_RESPONSE_TIMEOUT,
      error_code: `2004`,
    } }));
  }, []);

  useEffect(() => {
    if (!isReadyHeartbeat) return;
    if (socket.current) {
      socket.current.offAny();
      socket.current.close();
    }

    socket.current = io(uri, {
      ...opts,
      reconnectionAttempts: localStorage.getItem(CORS_ERROR_KEY) ? 3: undefined,
    });
    socket.current.on(SocketMessageType.CONNECT, onConnect);
    socket.current.on(SocketMessageType.DISCONNECT, onDisconnect);
    return () => {
      if (socket.current) {
        socket.current.offAny();
        socket.current.close();
      }
    }
  }, [uri, opts, isReadyHeartbeat]);

  return socket;
};